/* Ark redesign (QC) — home carousels: arrows, counter, keyboard, mouse drag with momentum, horizontal wheel.
   Manual only (no autoplay). Reuses the approved homepage drag/momentum logic. Safe to include more than once. */
(function () {
  if (window.arkRdCarousels) return;
  window.arkRdCarousels = true;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)');
  function init(root) {
    var track = root.querySelector('[data-rd-track]');
    if (!track || track.hasAttribute('data-rd-drag')) return;
    track.setAttribute('data-rd-drag', '');
    var prev = root.querySelector('[data-rd-prev]'), next = root.querySelector('[data-rd-next]'), count = root.querySelector('[data-rd-count]');
    var items = [].slice.call(track.children), last = -1, frame = 0;
    var max = function () { return track.scrollWidth - track.clientWidth; };
    var points = function () {
      var pad = parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0, base = track.getBoundingClientRect().left - track.scrollLeft + pad;
      return items.map(function (e) { return Math.min(max(), Math.max(0, e.getBoundingClientRect().left - base)); });
    };
    var behavior = function () { return reduce.matches ? 'auto' : 'smooth'; };
    function update() {
      frame = 0;
      var l = track.scrollLeft, m = max(), ps = points(), n = 0;
      for (var i = 1; i < ps.length; i++) if (Math.abs(ps[i] - l) < Math.abs(ps[n] - l)) n = i;
      if (m > 0 && l >= m - 2) n = items.length - 1;
      if (prev) prev.disabled = l <= 2;
      if (next) next.disabled = m <= 2 || l >= m - 2;
      if (count && n !== last) { count.textContent = String(n + 1).padStart(2, '0'); last = n; }
    }
    function go(dir) {
      var l = track.scrollLeft, ps = points(), t;
      if (dir > 0) t = ps.filter(function (x) { return x > l + 2; })[0];
      else t = ps.filter(function (x) { return x < l - 2; }).pop();
      if (t === undefined) t = dir > 0 ? max() : 0;
      track.scrollTo({ left: t, behavior: behavior() });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go(e.key === 'ArrowRight' ? 1 : -1); }
      else if (e.key === 'Home' || e.key === 'End') { e.preventDefault(); track.scrollTo({ left: e.key === 'Home' ? 0 : max(), behavior: behavior() }); }
    });
    track.addEventListener('scroll', function () { if (!frame) frame = requestAnimationFrame(update); }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    update();

    /* Mouse drag with momentum + horizontal wheel (approved live behaviour). Touch and trackpad stay native. */
    var anim = 0, set = null, wheelTimer = 0, drag = null, suppress = false;
    var release = function () { track.classList.remove('is-dragging'); };
    var cancel = function () { cancelAnimationFrame(anim); anim = 0; set = null; };
    function glide(projected) {
      cancel();
      var from = track.scrollLeft, ps = points();
      var to = ps.reduce(function (a, b) { return Math.abs(b - projected) < Math.abs(a - projected) ? b : a; }, ps[0] || 0);
      var dist = to - from;
      if (reduce.matches || Math.abs(dist) < 1) { track.scrollLeft = to; release(); return; }
      var dur = Math.min(750, Math.max(260, Math.abs(dist) * 0.9)), t0 = performance.now();
      track.classList.add('is-dragging');
      var step = function (now) {
        if (set !== null && Math.abs(track.scrollLeft - set) > 2) { cancel(); release(); return; }
        var p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        set = Math.round(from + dist * e); track.scrollLeft = set;
        if (p < 1) anim = requestAnimationFrame(step); else { cancel(); release(); }
      };
      anim = requestAnimationFrame(step);
    }
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      cancel(); drag = { id: e.pointerId, x: e.clientX, left: track.scrollLeft, moved: false, v: 0, lx: e.clientX, lt: e.timeStamp };
    });
    track.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(dx) < 6) return;
        drag.moved = true; track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); } catch (_) {}
        var s = getSelection && getSelection(); if (s) s.removeAllRanges();
      }
      e.preventDefault(); track.scrollLeft = drag.left - dx;
      var dt = e.timeStamp - drag.lt;
      if (dt > 0) { drag.v = 0.8 * ((e.clientX - drag.lx) / dt) + 0.2 * drag.v; drag.lx = e.clientX; drag.lt = e.timeStamp; }
    });
    var end = function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var d = drag; drag = null; if (!d.moved) return;
      suppress = true; setTimeout(function () { suppress = false; }, 0);
      var v = e.timeStamp - d.lt > 90 ? 0 : d.v; glide(track.scrollLeft - v * 260);
    };
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', function (e) { if (drag && e.pointerId === drag.id) { var d = drag; drag = null; if (d.moved) glide(track.scrollLeft); } });
    track.addEventListener('click', function (e) { if (suppress) { e.preventDefault(); e.stopPropagation(); suppress = false; } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    document.addEventListener('pointerdown', function (e) { if (anim && !track.contains(e.target)) { cancel(); release(); } }, true);
    track.addEventListener('wheel', function (e) {
      var delta = e.shiftKey && !e.deltaX ? e.deltaY : Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : 0;
      if (!delta || max() <= 0) return;
      var unit = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? track.clientWidth : 1, left = track.scrollLeft, nx = Math.min(max(), Math.max(0, left + delta * unit));
      if (nx === left) return;
      e.preventDefault(); cancel(); track.classList.add('is-dragging'); track.scrollLeft = nx;
      clearTimeout(wheelTimer); wheelTimer = setTimeout(function () { glide(track.scrollLeft); }, 140);
    }, { passive: false });
  }
  var run = function () { [].forEach.call(document.querySelectorAll('[data-rd-carousel]'), init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
